export default [
	{
		dataIndex: 'updated_at',
		key: 'datetime',
		title: 'Transaction Date & Time',
		align: 'center',
		scopedSlots: {customRender: 'datetime'},
		width: 145
	}, {
		key: 'merchant_code',
		title: 'Merchant Name',
		scopedSlots: {customRender: 'merchant_code'}
	}, {
		key: 'mid',
		title: 'MID',
		scopedSlots: {customRender: 'mid'}
	}, {
		key: 'tid',
		title: 'TID',
		scopedSlots: {customRender: 'tid'}
	}, {
		key: 'mpan',
		title: 'MPAN',
		scopedSlots: {customRender: 'mpan'}
	}, {
		key: 'cpan',
		title: 'CPAN',
		scopedSlots: {customRender: 'cpan'}
	}, {
		key: 'nmid',
		title: 'NMID',
		scopedSlots: {customRender: 'nmid'}
	}, {
		key: 'nmid_qris',
		title: 'MID PTEN/MID QRIS',
		scopedSlots: {customRender: 'nmid_qris'}
	}, {
		key: 'tid_qris',
		title: 'TID PTEN/TID QRIS',
		scopedSlots: {customRender: 'tid_qris'}
	}, {
		key: 'branch_code',
		title: 'Branch Code',
		scopedSlots: {customRender: 'branch_code'}
	}, {
		key: 'batch_no',
		title: 'Batch No',
		scopedSlots: {customRender: 'batch_no'}
	}, {
		key: 'account_number',
		title: 'Customer Account Number',
		scopedSlots: {customRender: 'account_number'}
	}, {
		key: 'pan',
		title: 'PAN',
		scopedSlots: {customRender: 'pan'}
	}, {
		key: 'product',
		title: 'Product Name',
		scopedSlots: {customRender: 'product'}
	}, {
		key: 'service_type',
		title: 'Service Type',
		scopedSlots: {customRender: 'service_type'}
	}, {
		key: 'customer_name',
		title: 'Customer Name',
		scopedSlots: {customRender: 'customer_name'}
	}, {
		key: 'issuer_name',
		title: 'Issuer Name',
		scopedSlots: {customRender: 'issuer_name'}
	}, {
		key: 'amount',
		title: 'Amount',
		scopedSlots: {customRender: 'amount'}
	}, {
		key: 'stan',
		title: 'STAN',
		scopedSlots: {customRender: 'stan'}
	}, {
		key: 'rrn',
		title: 'RRN/Reff ID',
		scopedSlots: {customRender: 'rrn'}
	}, {
		key: 'sn',
		title: 'S/N',
		scopedSlots: {customRender: 'sn'}
	}, {
		key: 'response_code',
		title: 'Response Code',
		scopedSlots: {customRender: 'response_code'}
	}, {
		key: 'response_message',
		title: 'Response Message',
		scopedSlots: {customRender: 'response_message'}
	}, {
		key: 'status',
		title: 'Status',
		scopedSlots: {customRender: 'status'}
	}, {
		key: 'raw',
		title: 'Raw Response',
		scopedSlots: {customRender: 'raw'}
	}
]
